<template>
<div class="chapter">
<div class="inner_page">
<nav epub:type="toc" id="toc" role="doc-toc">
<h1 id="toc-title">Odds Against</h1>
<ol class="toc">
<li>
<span href="#/text/cover" title="Link target outside of Sample">Cover</span>
</li>
<li id="title_page">
<a href="#/text/title_page">Title Page</a>
</li>
<li id="toc-li-1">
<a href="#/text/ch001#chapter-1">Chapter 1</a>
</li>
<li id="toc-li-2">
<a href="#/text/ch002#chapter-2">Chapter 2</a>
</li>
<li id="toc-li-3">
<span href="#/text/ch003#chapter-3" title="Link target outside of Sample">Chapter 3</span>
</li>
<li id="toc-li-4">
<span href="#/text/ch004#chapter-4" title="Link target outside of Sample">Chapter 4</span>
</li>
<li id="toc-li-5">
<span href="#/text/ch005#chapter-5" title="Link target outside of Sample">Chapter 5</span>
</li>
<li id="toc-li-6">
<span href="#/text/ch006#chapter-6" title="Link target outside of Sample">Chapter 6</span>
</li>
<li id="toc-li-7">
<span href="#/text/ch007#chapter-7" title="Link target outside of Sample">Chapter 7</span>
</li>
<li id="toc-li-8">
<span href="#/text/ch008#chapter-8" title="Link target outside of Sample">Chapter 8</span>
</li>
<li id="toc-li-9">
<span href="#/text/ch009#chapter-9" title="Link target outside of Sample">Chapter 9</span>
</li>
<li id="toc-li-10">
<span href="#/text/ch010#chapter-10" title="Link target outside of Sample">Chapter 10</span>
</li>
<li id="toc-li-11">
<span href="#/text/ch011#chapter-11" title="Link target outside of Sample">Chapter 11</span>
</li>
<li id="toc-li-12">
<span href="#/text/ch012#chapter-12" title="Link target outside of Sample">Chapter 12</span>
</li>
<li id="toc-li-13">
<span href="#/text/ch013#chapter-13" title="Link target outside of Sample">Chapter 13</span>
</li>
<li id="toc-li-14">
<span href="#/text/ch014#chapter-14" title="Link target outside of Sample">Chapter 14</span>
</li>
<li id="toc-li-15">
<span href="#/text/ch015#chapter-15" title="Link target outside of Sample">Chapter 15</span>
</li>
<li id="toc-li-16">
<span href="#/text/ch016#chapter-16" title="Link target outside of Sample">Chapter 16</span>
</li>
<li id="toc-li-17">
<span href="#/text/ch017#chapter-17" title="Link target outside of Sample">Chapter 17</span>
</li>
<li id="toc-li-18">
<span href="#/text/ch018#chapter-18" title="Link target outside of Sample">Chapter 18</span>
</li>
<li id="toc-li-19">
<span href="#/text/ch019#chapter-19" title="Link target outside of Sample">Chapter 19</span>
</li>
<li id="toc-li-20">
<span href="#/text/ch020#chapter-20" title="Link target outside of Sample">Chapter 20</span>
</li>
<li id="toc-li-21">
<span href="#/text/ch021#copyright" title="Link target outside of Sample">Copyright</span>
</li>
</ol>
</nav>
<nav epub:type="landmarks" hidden="hidden" id="landmarks">
<ol>
<li>
<span epub:type="cover" href="#/text/cover" title="Link target outside of Sample">Cover</span>
</li>
<li>
<a epub:type="toc" href="#/nav#toc">Table of Contents</a>
</li>
<li>
<a epub:type="bodymatter" href="#/text/title_page">Start of Content</a>
</li>
</ol>
</nav>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nav.vue?46e2ae5e